var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":_vm.avatarSize}},[(_vm.image)?_c('v-img',{attrs:{"src":_vm.image,"size":_vm.iconSize}}):_c('v-icon',{attrs:{"color":_vm.color,"size":_vm.iconSize}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }